import { Button } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { theme } from '@store';
import { paths } from '@common/types';
import { useCreateAssessmentExternalLinkMutation } from '@common/cache';
import { toast } from 'react-toastify';
import { formatApiError } from '@common/errors/error-formatting';

interface ICopyAssessmentLinkProps {
  assessment: paths[`/patient/{patient_id}/assessment/{assessment_id}`]['get']['responses']['200']['content']['application/json'];
  patient_id?: string;
}

export const CopyAssessmentLink = ({
  assessment,
  patient_id = '',
}: ICopyAssessmentLinkProps) => {
  const createLinkMutation = useCreateAssessmentExternalLinkMutation();
  const { can_link_be_generated } = assessment;

  const handleGenerateLink = async () => {
    try {
      const response = await createLinkMutation.mutateAsync({
        assessment_id: assessment.id,
        patient_id,
      });

      navigator.clipboard.writeText(response.data.link);
      toast.success('Link to the assessment copied!');
    } catch (error) {
      toast.error(formatApiError(error));
    }
  };

  return (
    can_link_be_generated && (
      <Button
        variant='outlined'
        sx={{
          width: 'fit-content',
          padding: '6px 10px',
          border: `1px solid ${theme.palette.primary.main}`,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '0.5rem',
        }}
        onClick={handleGenerateLink}
        disabled={createLinkMutation.isPending}
      >
        <ContentCopyIcon
          sx={{
            color: theme.palette.primary.main,
            fontSize: `20px`,
          }}
        />
        COPY LINK TO ASSESSMENT
      </Button>
    )
  );
};
